import React from "react";

const License = () => {
    return (
        <div>
            The text of this work is licensed under a Creative Commons Attribution- NonCommercial 4.0 International License. You may create your own Wondrous Terrible stories, scenarios, art, and all other forms of game material and distribute them freely, provided your work includes this paragraph at the beginning, provided it gives credit to the team that created and published Wondrous Terrible, provided it is a non-commercial project, and provided any works that are made from your project follow the same restrictions.
        </div>
    )
}

export default License